import moment from "moment";
import { convertToLowestUnit, GetUpdatedDelivered } from "./units";

const getDateRangeFromMonth = (monthYear) => {
    if (!monthYear) return null;
  
    const [year, month] = monthYear.split('-');
    const startDate = moment(`${year}-${month}-01`);
    const endDate = moment();

    if (startDate.format('YYYY-MM') === moment().format('YYYY-MM')) {
      return {
        startDate: startDate.format('YYYY-MM-DD'),
        endDate: endDate.format('YYYY-MM-DD')
      };
    } else {
      return {
        startDate: startDate.format('YYYY-MM-DD'),
        endDate: startDate.endOf('month').format('YYYY-MM-DD')
      };
    }
};
function mergeDuplicateProducts(items) {
    if (!items?.length) return [];
    
    return Object.values(items.reduce((acc, item) => {
      
      if (!acc[item.product_id]) {
        acc[item.product_id] = { ...item,
           is_free: item?.is_free || false
         };
      } else {          
            // Convert both quantities to lowest unit and sum them
            const convertedQty = convertToLowestUnit(
                item.unit_levels,
                item.received_quantity
            );
            const existingQty = convertToLowestUnit(
                acc[item.product_id].unit_levels,
                acc[item.product_id].received_quantity
            );
            const lowestUnit = item.unit_levels.at(-1).unit;
            
            const summedQuantity = [{unit: lowestUnit,value: Number(convertedQty + existingQty)}];
            
            acc[item.product_id].received_quantity = GetUpdatedDelivered(summedQuantity,item.unit_levels);
            acc[item.product_id].receiving_cost += Number(item.receiving_cost);       
            acc[item.product_id].is_free = acc[item.product_id].is_free || item?.is_free;
           }
        return acc;
    }, {}));
}

 function mergeDuplicateProdQuantity(items) {
  if (!items?.length) return [];
  
  return Object.values(items.reduce((acc, item) => {
    
    if (!acc[item.product_id]) {
      acc[item.product_id] = { ...item };
    } else {          
          // Convert both quantities to lowest unit and sum them
          const convertedQty = convertToLowestUnit(
              item.unit_levels,
              item.quantity
          );
          const existingQty = convertToLowestUnit(
              acc[item.product_id].unit_levels,
              acc[item.product_id].quantity
          );
          const lowestUnit = item.unit_levels.at(-1).unit;
          
          const summedQuantity = [{unit: lowestUnit,value: Number(convertedQty + existingQty)}];
          
          acc[item.product_id].quantity = GetUpdatedDelivered(summedQuantity,item.unit_levels);
          acc[item.product_id].receiving_cost += Number(item.receiving_cost);        }
      return acc;
  }, {}));
}  

function mergeDuplicateItems(items) {
  if (!items?.length) return [];
  
  return Object.values(items.reduce((acc, item) => {
    
    if (!acc[item.item_id]) {
      acc[item.item_id] = { ...item,
        is_free: item.is_free || false 
       };
    } else {          
          // Convert both quantities to lowest unit and sum them
          const convertedQty = convertToLowestUnit(
              item.unit_levels,
              item.received_quantity
          );
          const existingQty = convertToLowestUnit(
              acc[item.item_id].unit_levels,
              acc[item.item_id].received_quantity
          );
          const lowestUnit = item.unit_levels.at(-1).unit;
          
          const summedQuantity = [{unit: lowestUnit,value: Number(convertedQty + existingQty)}];
          
          acc[item.item_id].received_quantity = GetUpdatedDelivered(summedQuantity,item.unit_levels);
          acc[item.item_id].receiving_cost += Number(item.receiving_cost);       
          acc[item.item_id].is_free = acc[item.item_id].is_free || item.is_free;

        }
      return acc;
  }, {}));
} 

function mergeDuplicateItemsQuantity(items) {
if (!items?.length) return [];

return Object.values(items.reduce((acc, item) => {
  
  if (!acc[item.item_id]) {
    acc[item.item_id] = { ...item, is_free: item.is_free || false };
  } else {          
        // Convert both quantities to lowest unit and sum them
        const convertedQty = convertToLowestUnit(
            item.unit_levels,
            item.quantity
        );
        const existingQty = convertToLowestUnit(
            acc[item.item_id].unit_levels,
            acc[item.item_id].quantity
        );
        const lowestUnit = item.unit_levels.at(-1).unit;
        
        const summedQuantity = [{unit: lowestUnit,value: Number(convertedQty + existingQty)}];
        
        acc[item.item_id].quantity = GetUpdatedDelivered(summedQuantity,item.unit_levels);
        acc[item.item_id].receiving_cost += Number(item.receiving_cost); 
        acc[item.item_id].is_free = acc[item.item_id].is_free || item.is_free;
      }
    return acc;
}, {}));
} 

function mergeDuplicateItemsQuantityForOpening(items) {
if (!items?.length) return [];

return Object.values(items.reduce((acc, item) => {
  
  if (!acc[item.item_id]) {
    acc[item.item_id] = { ...item, is_free: item.is_free || false };
  } else {          
        // Convert both quantities to lowest unit and sum them
        const convertedQty = convertToLowestUnit(
            item.unit_levels,
            item.quantity
        );
        const existingQty = convertToLowestUnit(
            acc[item.item_id].unit_levels,
            acc[item.item_id].quantity
        );
        const lowestUnit = item.unit_levels.at(-1).unit;
        
        const summedQuantity = [{unit: lowestUnit,value: Number(convertedQty + existingQty)}];
        
        acc[item.item_id].quantity = GetUpdatedDelivered(summedQuantity,item.unit_levels);
        acc[item.item_id].total_cost += Number(item.total_cost); 
        acc[item.item_id].is_free = acc[item.item_id].is_free || item.is_free;
      }
    return acc;
}, {}));
} 

function mergeDuplicateProductsQuantityForOpening(products) {
if (!products?.length) return [];

return Object.values(products.reduce((acc, product) => {
  
  if (!acc[product.product_id]) {
    acc[product.product_id] = { ...product, is_free: product.is_free || false };
  } else {          
        // Convert both quantities to lowest unit and sum them
        const convertedQty = convertToLowestUnit(
            product.unit_levels,
            product.quantity
        );
        const existingQty = convertToLowestUnit(
            acc[product.product_id].unit_levels,
            acc[product.product_id].quantity
        );
        const lowestUnit = product.unit_levels.at(-1).unit;
        
        const summedQuantity = [{unit: lowestUnit,value: Number(convertedQty + existingQty)}];
        
        acc[product.product_id].quantity = GetUpdatedDelivered(summedQuantity,product.unit_levels);
        acc[product.product_id].total_cost += Number(product.total_cost); 
        acc[product.product_id].is_free = acc[product.product_id].is_free || product.is_free;
      }
    return acc;
}, {}));
} 

function mergeDuplicateItemsQuantityForStore(items,isItem) {
  if (!items?.length) return [];
  
  return Object.values(items.reduce((acc, item) => {
    let key = null;
    if(isItem){
       key = `${item.item_id}-${item.source || 'default'}`;
    } else {
       key = `${item.product_id}-${item.source || 'default'}`;
    }
    if (!acc[key] ) {
      acc[key] = { ...item, is_free: item.is_free || false };
    } else {          
          // Convert both quantities to lowest unit and sum them
          const convertedQty = convertToLowestUnit(
              item.unit_levels,
              item.quantity
          );
          const existingQty = convertToLowestUnit(
              acc[key].unit_levels,
              acc[key].quantity
          );
          const lowestUnit = item.unit_levels.at(-1).unit;
          
          const summedQuantity = [{unit: lowestUnit,value: Number(convertedQty + existingQty)}];
          
          acc[key].quantity = GetUpdatedDelivered(summedQuantity,item.unit_levels);
          acc[key].receiving_cost += Number(item.receiving_cost); 
          acc[key].is_free = acc[key].is_free || item.is_free;
        }
      return acc;
  }, {}));
}

  export { 
    getDateRangeFromMonth,
    mergeDuplicateProducts,
    mergeDuplicateProdQuantity,
    mergeDuplicateItems,
    mergeDuplicateItemsQuantity,
    mergeDuplicateProductsQuantityForOpening,
    mergeDuplicateItemsQuantityForOpening,
    mergeDuplicateItemsQuantityForStore
   };